export default "__VITE_ASSET__2ZfPpdyh__"